/*
 * © 2026 Ecsper Ltd. All rights reserved.
 * SPDX-License-Identifier: LicenseRef-Ecsper-Proprietary
 * Unauthorised use, copying, or distribution is strictly prohibited.
 */

import type { TemplateReference } from '@ecsper/speciality-contract';

export const expertWitnessTemplates: readonly TemplateReference[] = [
  {
    id: 'cpr-part-35-report',
    host: 'word',
    displayName: { 'en-GB': 'CPR Part 35 Expert Report' },
    description: {
      'en-GB': 'Standard expert witness report template aligned with CPR Part 35 requirements',
    },
    version: '1.0.0',
  },
] as const;
